import { Stack, Typography } from '@mui/material';
import ChatDisclaimer from './ChatDisclaimer';

interface ChatHeaderProps {
  title: string;
  isScrolled?: boolean;
}

const ChatHeader = ({ title, isScrolled }: ChatHeaderProps): JSX.Element => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      padding={2}
      sx={{
        height: '64px',
        borderBottom: isScrolled ? '1px solid #e0e0e0' : 'none',
        transition: 'border-bottom 0.2s',
      }}>
      <Typography variant="h6">{title}</Typography>
      <Stack direction="row" alignItems="center" gap={1} flexGrow={1} justifyContent="flex-end">
        <ChatDisclaimer />
      </Stack>
    </Stack>
  );
};

export default ChatHeader;
